import api from "../config/api";
import type { ApiResponse, Course, PaginatedResponse, ServiceCategory } from "../types";

export interface CreateServiceCategoryRequest {
  name: string;
  description?: string;
  icon?: string;
  sortOrder?: number;
}

export const serviceService = {
  getServiceCategories: async (params: any = {}): Promise<PaginatedResponse<ServiceCategory>> => {
    const response = await api.get('/services/categories', { params });
    return response.data;
  },

  getServiceCategory: async (id: string): Promise<ApiResponse<{ category: ServiceCategory; courses: Course[] }>> => {
    const response = await api.get(`/services/categories/${id}`);
    return response.data;
  },

  createServiceCategory: async (data: CreateServiceCategoryRequest): Promise<ApiResponse<ServiceCategory>> => {
    const response = await api.post('/services/categories', data);
    return response.data;
  },

  updateServiceCategory: async (id: string, data: Partial<CreateServiceCategoryRequest>): Promise<ApiResponse<ServiceCategory>> => {
    const response = await api.put(`/services/categories/${id}`, data);
    return response.data;
  },

  deleteServiceCategory: async (id: string): Promise<ApiResponse<ServiceCategory>> => {
    const response = await api.delete(`/services/categories/${id}`);
    return response.data;
  },
};